module.exports = __webpack_public_path__ + "static/media/1.c8fe2a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/80035/1.jpg
// module id = 725
// module chunks = 0